// import Consent from "./consent";
import { modal } from "bootstrap";

import CompliantConsentManager from "./consent.js";

document.addEventListener("DOMContentLoaded", function () {
    // Initialize consent manager
    const consentBanner = document.getElementById("tessellate-consent-banner");
    let consentManager;

    // first check if gtag is defined
    if (typeof window.gtag === "function" && consentBanner) {
        consentManager = new CompliantConsentManager();

        const cookieConsent = consentManager.getConsentFromCookie();

        // Show if consent options are not set
        if (!cookieConsent) {
            document.getElementById("tessellate-consent-banner").style.display = "block";
        }
    }

    if (consentBanner) {
        document.querySelectorAll(".consent-btn--grant").forEach((button) => {
            button.addEventListener("click", () => consentManager.grantConsent());
        });

        document.getElementById("confirm-btn").addEventListener("click", () => {
            const consentModal = document.getElementById("consentModal");
            const checkboxes = consentModal.querySelectorAll("input[type='checkbox']");
            const obj = {};

            checkboxes.forEach((checkbox) => {
                obj[checkbox.id] = checkbox.checked ? "granted" : "denied";
            });

            if (obj["ad_storage"] === "denied") {
                obj["ad_user_data"] = "denied";
                obj["ad_personalization"] = "denied";
            }

            if (obj["ad_storage"] === "granted") {
                obj["ad_user_data"] = "granted";
                obj["ad_personalization"] = "granted";
            }

            consentManager.updateConsent(obj);

            document.getElementById("tessellate-consent-banner").style.display = "none";
        });

        document.querySelectorAll(".consent-btn--update-all").forEach((button) => {
            button.addEventListener("click", () => {
                const obj = {};
                document.getElementById("ad_storage").setAttribute("checked", "true");

                document.getElementById("analytics_storage").setAttribute("checked", "true");

                obj["ad_storage"] = "granted";
                obj["ad_user_data"] = "granted";
                obj["ad_personalization"] = "granted";
                obj["analytics_storage"] = "granted";

                if (site_data.meta == "yes") {
                    if (window.pys) {
                        obj["meta"] = "granted";
                    }
                }

                consentManager.updateConsent(obj);

                document.getElementById("tessellate-consent-banner").style.display = "none";
            });
        });
    }
});
